module.exports = __webpack_public_path__ + "img/lupa_buscar.396e7015.svg";